// import React, { Suspense, useEffect } from 'react';

// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { GetReportsList } from '@store/NTX/Reports/reportSlice';
// import ReportsAllByModule from '../../NTX/Reports/ReportsModule/Index';
// import { v4 as uuidv4 } from 'uuid';
// import LazyLoading from '@config/LazyLoading/LazyLoading';

// const BranchTransfers_Paged = React.lazy(() => import('./BranchTransfers_Paged'));

// const AccountStatement = React.lazy(() => import('./FinancialReports/AccountStatement'));

// const AuditBalance = React.lazy(() => import('./FinancialReports/AuditBalance'));

// const BalanceSheet = React.lazy(() => import('./FinancialReports/BalanceSheet'));

// const IncomeStatement = React.lazy(() => import('./FinancialReports/IncomeStatement'));

// interface Report {
//   id: string;
//   name: string;
//   name2: string;
//   moduleId: string;
//   tableName: string;
//   query: string;
//   description: string;
//   pageType: string;
//   reportType: string;
// }

// interface ReportsListState {
//   ReportsList: Report[];
//   loading: boolean;
// }

// //________________ Start Components
// const FinanceReports: React.FC = () => {
//   const dispatch = useAppDispatch();

//   const { ReportsList, loading } = useAppSelector(state => state.Reports) as ReportsListState;
//   useEffect(() => {
//     dispatch(GetReportsList());
//   }, [dispatch]);

//   const reportListByModule = ReportsList?.filter(
//     f => f.moduleId?.toLowerCase() === '0a6c6b89-1d52-4eaa-8d2c-050c74b1f6e0'
//   );

//   const reports = [
//     // العناصر القادمة من النظام (تقارير مخصصة)
//     ...(reportListByModule ?? []).map(report => ({
//       ...report,
//       type: 'custom',
//       component: null // لا يوجد مكون ثابت
//     })),

//     {
//       id: uuidv4(),
//       name2: 'تقرير التحويلات بين الفروع',
//       name: 'Branch Transfers Report',
//       icon: 'fas fa-exchange-alt',
//       type: 'static',
//       component: (
//         <Suspense fallback={<LazyLoading />}>
//           <BranchTransfers_Paged />
//         </Suspense>
//       )
//     },
//     {
//       id: uuidv4(),
//       name2: 'كشف حساب',
//       name: 'Account Statement Report',
//       icon: 'fas fa-receipt',
//       type: 'static',
//       component: (
//         <Suspense fallback={<LazyLoading />}>
//           <AccountStatement />
//         </Suspense>
//       )
//     },
//     {
//       id: uuidv4(),
//       name2: 'ميزان المراجعة',
//       name: 'Trial Balance Report',
//       icon: 'fas fa-scale-balanced',
//       type: 'static',
//       component: (
//         <Suspense fallback={<LazyLoading />}>
//           <AuditBalance />
//         </Suspense>
//       )
//     },
//     {
//       id: uuidv4(),
//       // name2: 'الميزانية العمومية',
//       name2: 'المركز المالي',
//       name: 'Balance Sheet Report',
//       icon: 'fas fa-file-invoice',
//       type: 'static',
//       component: (
//         <Suspense fallback={<LazyLoading />}>
//           <BalanceSheet />
//         </Suspense>
//       )
//     },
//     {
//       id: uuidv4(),
//       name2: 'قائمة الدخل',
//       name: 'Income Statement Report',
//       icon: 'fas fa-chart-line',
//       type: 'static',
//       component: (
//         <Suspense fallback={<LazyLoading />}>
//           <IncomeStatement />
//         </Suspense>
//       )
//     }
//   ];

//   return (
//     <>
//       <ReportsAllByModule ReportsList={reports} loading={loading} reportType='both' />
//     </>
//   );
// };

// export default FinanceReports;

import React, { Suspense, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { GetReportsList } from '@store/NTX/Reports/reportSlice';
import ReportsAllByModule from '../../NTX/Reports/ReportsModule/Index';
import { v4 as uuidv4 } from 'uuid';
import LazyLoading from '@config/LazyLoading/LazyLoading';

const BranchTransfers_Paged = React.lazy(() => import('./BranchTransfers_Paged'));

// إضافة المكون الجديد هنا
const InterBranchStatement_Paged = React.lazy(() => import('./InterBranchStatement_Paged'));

const AccountStatement = React.lazy(() => import('./FinancialReports/AccountStatement'));

const AuditBalance = React.lazy(() => import('./FinancialReports/AuditBalance'));

const BalanceSheet = React.lazy(() => import('./FinancialReports/BalanceSheet'));

const IncomeStatement = React.lazy(() => import('./FinancialReports/IncomeStatement'));

const AnalyticPartyStatement_Paged = React.lazy(() => import('./AnalyticPartyStatement_Paged'));

const ExpensesDetails_Paged = React.lazy(() => import('./ExpensesDetails_Paged'));

const TaxDeclarationStatement_Paged = React.lazy(() => import('./TaxDeclarationStatement_Paged'));

const GlAccountStatement_Paged = React.lazy(() => import('./GlAccountStatement_Paged'));

// ✅ إضافة استيراد تقرير مطابقة ضريبة المشتريات الجديد
const TaxReconciliationPurchase_Paged = React.lazy(() => import('./TaxReconciliationPurchase_Paged'));

interface Report {
  id: string;
  name: string;
  name2: string;
  moduleId: string;
  tableName: string;
  query: string;
  description: string;
  pageType: string;
  reportType: string;
}

interface ReportsListState {
  ReportsList: Report[];
  loading: boolean;
}

//________________ Start Components
const FinanceReports: React.FC = () => {
  const dispatch = useAppDispatch();

  const { ReportsList, loading } = useAppSelector(state => state.Reports) as ReportsListState;
  useEffect(() => {
    dispatch(GetReportsList());
  }, [dispatch]);

  const reportListByModule = ReportsList?.filter(
    f => f.moduleId?.toLowerCase() === '0a6c6b89-1d52-4eaa-8d2c-050c74b1f6e0'
  );

  const reports = [
    // العناصر القادمة من النظام (تقارير مخصصة)
    ...(reportListByModule ?? []).map(report => ({
      ...report,
      type: 'custom',
      component: null // لا يوجد مكون ثابت
    })),

    // {
    //   id: uuidv4(),
    //   name2: 'تقرير التحويلات بين الفروع',
    //   name: 'Branch Transfers Report',
    //   icon: 'fas fa-exchange-alt',
    //   type: 'static',
    //   component: (
    //     <Suspense fallback={<LazyLoading />}>
    //       <BranchTransfers_Paged />
    //     </Suspense>
    //   )
    // },
    // إضافة كشف حساب بين الفروع هنا
    {
      id: uuidv4(),
      name2: 'كشف حساب بين الفروع',
      name: 'Inter-Branch Statement Report',
      icon: 'fas fa-file-invoice-dollar',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <InterBranchStatement_Paged />
        </Suspense>
      )
    },

    {
      id: uuidv4(),
      name2: 'كشف حساب تحليلي',
      name: 'Analytic Party Statement Report',
      icon: 'fas fa-users-cog', // أيقونة مناسبة
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <AnalyticPartyStatement_Paged />
        </Suspense>
      )
    },

    {
      id: uuidv4(),
      name2: 'تقرير تفاصيل المصروفات',
      name: 'Expenses Details Report',
      icon: 'fas fa-wallet',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <ExpensesDetails_Paged />
        </Suspense>
      )
    },

    {
      id: uuidv4(),
      name: 'GL Account Statement',
      name2: 'كشف حساب أستاذ عام',
      icon: 'fas fa-book',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <GlAccountStatement_Paged />
        </Suspense>
      )
    },

    // {
    //   id: uuidv4(),
    //   name2: 'كشف حساب',
    //   name: 'Account Statement Report',
    //   icon: 'fas fa-receipt',
    //   type: 'static',
    //   component: (
    //     <Suspense fallback={<LazyLoading />}>
    //       <AccountStatement />
    //     </Suspense>
    //   )
    // },
    {
      id: uuidv4(),
      name2: 'ميزان المراجعة',
      name: 'Trial Balance Report',
      icon: 'fas fa-scale-balanced',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <AuditBalance />
        </Suspense>
      )
    },
    {
      id: uuidv4(),
      // name2: 'الميزانية العمومية',
      name2: 'المركز المالي',
      name: 'Balance Sheet Report',
      icon: 'fas fa-file-invoice',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <BalanceSheet />
        </Suspense>
      )
    },
    {
      id: uuidv4(),
      name2: 'قائمة الدخل',
      name: 'Income Statement Report',
      icon: 'fas fa-chart-line',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <IncomeStatement />
        </Suspense>
      )
    },
    {
      id: uuidv4(),
      name: 'Tax Declaration Statement',
      name2: 'بيان الإقرار الضريبي',
      icon: 'fas fa-file-invoice-dollar',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <TaxDeclarationStatement_Paged />
        </Suspense>
      )
    },

    // ✅ إضافة تقرير مطابقة ضريبة المشتريات هنا
    {
      id: uuidv4(),
      name: 'Purchase Tax Reconciliation',
      name2: 'مطابقة ضريبة المشتريات',
      icon: 'fas fa-clipboard-check',
      type: 'static',
      component: (
        <Suspense fallback={<LazyLoading />}>
          <TaxReconciliationPurchase_Paged />
        </Suspense>
      )
    }
  ];

  return (
    <>
      <ReportsAllByModule ReportsList={reports} loading={loading} reportType='both' />
    </>
  );
};

export default FinanceReports;
